import { ArrowRight } from "lucide-react";

const sites = [
  {
    name: "Aïr et Ténéré",
    desc: "Paysages désertiques exceptionnels",
    image: "/images/at.png",
  },
  {
    name: "Parc National du W",
    desc: "Biodiversité unique au Niger",
    image: "/images/parc.jpg",
  },
  {
    name: "Termit et Tin Merzouga",
    desc: "Patrimoine naturel classé UNESCO",
    image: "/images/desert.jpg",
  },
  {
    name: "Djenné de Damagaram",
    desc: "Monument historique emblématique",
    image: "/images/agadez.jpg",
  },
  {
    name: "Gorges de Kourou",
    desc: "Beauté naturelle et authentique",
    image: "/images/ee.jpeg",
  },
];

export default function DestinationsSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-end justify-between mb-5">
        <h2 className="text-xl md:text-2xl font-bold text-slate-800">Sites touristiques</h2>
        <button className="flex items-center gap-1 text-brand-600 hover:text-brand-700 text-sm font-semibold">
          Voir tous les sites <ArrowRight size={15} />
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {sites.map((site, i) => (
          <div key={i} className="cursor-pointer group">
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-slate-100">
              <img
                src={site.image}
                alt={site.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <h3 className="mt-3 font-semibold text-slate-800 text-sm leading-tight group-hover:text-brand-600 transition-colors">
              {site.name}
            </h3>
            <p className="text-xs text-slate-500 mt-1 leading-snug">{site.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
